'use client';

import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { createClient } from '@/lib/supabase/client';
import PartnerLogin from './AdminLogin';
import PartnerDashboard from './PartnerDashboard';

const AdminDashboard = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!user) {
      setIsPartner(false);
      return;
    }

    const checkPartnerAccess = async () => {
      setIsChecking(true);
      try {
        const supabase = createClient();
        const { data: profile } = await supabase?.from('profiles')?.select('id')?.eq('id', user?.id)?.maybeSingle();
        setIsPartner(!!profile);
      } catch {
        setIsPartner(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkPartnerAccess();
  }, [user]);

  if (!isHydrated || isChecking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user || !isPartner) {
    return <PartnerLogin />;
  }

  return <PartnerDashboard />;
};

export default AdminDashboard;